<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn class="no-print" @click="newMonitoreoAuditivoCs" v-if="this.$store.state.routeSheet.status=='true'" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select
                            v-model="monitoreoAuditivoCs"
                            :items="listMonitoreoAuditivoCs"
                            label="Historial"
                            item-text="fecha"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-model="panel" expand v-if="monitoreoAuditivoCs!=null">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación:
                                            {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres:
                                            {{$store.state.patient.firstLastName}}
                                            {{$store.state.patient.secondLastName}} {{$store.state.patient.firstName}}
                                            {{$store.state.patient.secondName}} </p>
                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad:
                                            {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa:
                                            {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo:
                                            {{$store.state.patient.jobCompany}}</p>
                                        <p v-if="props.item.tipo==0 && !props.item.bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==0 && props.item.bold" class="font-weight-bold">
                                            {{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>


                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 2. Antecedentes personales auditivos/auriculares</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.antecedentesPersonales"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>


                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>3. Antecedentes patológicos generales</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.antecedentesPatologicos"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>


                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-textarea
                                                v-if="props.item.tipo==3"
                                                :label="props.item.label"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 5000) || 'El número de caracteres debe ser menor a 5000']"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-textarea>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>4. Antecedentes de familiares cercanos (Padre-madre-hermanos) con problemas auditivos</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.antecedentesFamiliaresCercanos"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>


                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-textarea
                                                v-if="props.item.tipo==3"
                                                :label="props.item.label"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 5000) || 'El número de caracteres debe ser menor a 5000']"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-textarea>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>5. Sintomatología actual</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.sintomalogiaActual"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>


                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="props.item.tipo==3"
                                                :label="props.item.label"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-text-field>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>6. Exploración del aparato auditivo y otros</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.exploracion"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>

                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-textarea
                                                v-if="props.item.tipo==3"
                                                :label="props.item.label"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 5000) || 'El número de caracteres debe ser menor a 5000']"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-textarea>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>7. Se realizó audiometría</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.hizoAudiometria"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>

                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="props.item.tipo==3"
                                                :label="props.item.label"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-text-field>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>8. Dispone de sonometría/dosimetría en el puesto de trabajo</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <td v-if="sonometria!=''">
                                <v-text-field
                                        label="Sonometría"
                                        v-model="sonometria"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        label="Dosimetría"
                                        v-model="dosimetria"
                                        required
                                ></v-text-field>
                            </td>
                            <v-data-table v-if="sonometria==''"
                                    :items="this.monitoreoAuditivoCs.disponeSometria"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td  class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>

                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="props.item.tipo==3 "
                                                :label="props.item.label"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-text-field>
                                    </td>

                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>9. Ha recibido capacitaciones sobre ...</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.capacitaciones"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>

                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="props.item.tipo==3"
                                                :label="props.item.label"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-text-field>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>10. Conclusiones del estado de salud</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.conclusiones"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>


                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-textarea
                                                v-if="props.item.tipo==5"
                                                :label="props.item.label"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 5000) || 'El número de caracteres debe ser menor a 5000']"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-textarea>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>11. Recomendaciones en el campo de la salud (seguimiento, interconsulta, medidas de
                            protección, capacitación) (ver documento del programa y seguir los procedimientos que se
                            tiene para las interconsultas en la HCU).
                        </div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.monitoreoAuditivoCs.recomendaciones"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0" >{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>


                                        <v-select
                                                v-if="props.item.tipo==1"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-select
                                                v-if="props.item.tipo==2"
                                                :items="props.item.data"
                                                v-model="props.item.valor"
                                                :label="props.item.label"
                                                required
                                        ></v-select>
                                        <v-text-field
                                                v-if="props.item.tipo==2"
                                                :label="props.item.label2"
                                                v-model="props.item.valor2"
                                                required
                                        ></v-text-field>
                                        <v-textarea
                                                v-if="props.item.tipo==5"
                                                :label="props.item.label"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 5000) || 'El número de caracteres debe ser menor a 5000']"
                                                v-model="props.item.descripcion"
                                                required
                                        ></v-textarea>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="monitoreoAuditivoCs!=null">
            <v-btn color="primary" class="no-print" @click="saveMonitoreoAuditivoCs" v-if="this.$store.state.routeSheet.status=='true'" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

    import MonitoreoAudivoCs from "../../../model/MonitoreoAudivoCs"
    import PatientMonitoring from "../../../model/PatientMonitoring";

    export default {
        props: ['company'],
        data() {
            return {
                panel:[true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],
                monitoreoAuditivoCs: null,
                listMonitoreoAuditivoCs: [],
                radioGroup: 1,
                search: '',
                dialogError:false,
                dialogSucess:false,
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                jobs: [],
                dialogSuccess: false,
                sonometria:"",
                dosimetria:"",
                diagnosticos: [
                    {elemento: "Físicos", procesoPeligroso: "Temperatura elevada"},
                    {elemento: "Físicos", procesoPeligroso: "Temperatura baja"},
                    {elemento: "Físicos", procesoPeligroso: "Radiaciones ionizantes"},
                    {
                        elemento: "Biológicos",
                        procesoPeligroso: "Presencia de vectores (roedores, moscas, cucarachas)\t"
                    },
                    {elemento: "Biológicos", procesoPeligroso: "Bacterias, hongos, parásitos y virus"},
                    {elemento: "Biológicos", procesoPeligroso: "Alergenos de origen vegetal o animal"},
                    {elemento: "Biológicos", procesoPeligroso: "Consumo de alimentos no garantizados"},
                    {elemento: "Biológicos", procesoPeligroso: "Animales venenosos o ponzoñosos"},
                ],
            };
        },
        methods: {

            newMonitoreoAuditivoCs() {
                let d = new Date();
                let e = this.formatDate(d);
                this.monitoreoAuditivoCs = new MonitoreoAudivoCs()
                this.monitoreoAuditivoCs.fecha = e
                this.listMonitoreoAuditivoCs.push(this.monitoreoAuditivoCs)
            },

            saveMonitoreoAuditivoCs() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList=[]
                    if(this.monitoreoAuditivoCs.id!='' && this.monitoreoAuditivoCs.id!=null){
                        this.$store.dispatch('getPatientMonitoring',this.monitoreoAuditivoCs.id).then(response => {
                            this.$store.state.patientMonitoringOne.value=JSON.stringify(this.monitoreoAuditivoCs)
                            this.$store.dispatch('updatePatientMonitoring',this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    }else{
                        let monitoringNew=new PatientMonitoring()
                        monitoringNew.date=new Date()
                        monitoringNew.value=JSON.stringify(this.monitoreoAuditivoCs)
                        monitoringNew.form=1
                        monitoringNew.patientRouteSheet=this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring',monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            reloadData(){
                let data= new PatientMonitoring()
                data.form = 1
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date= new Date()
                data.value= ""
                this.monitoreoAuditivoCs = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm',data).then(response => {
                    this.listMonitoreoAuditivoCs= []
                    for(let i=0; i<this.$store.state.patientMonitoringList.length;i++){
                        let anam=JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id=this.$store.state.patientMonitoringList[i].id
                        this.listMonitoreoAuditivoCs.push(anam)
                        console.log(anam.disponeSometria[0].valor=='SI')
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
                this.$store.dispatch('getCompanyJobsByCompany',this.$store.state.routeSheet.patient.company.id)
                    .then(response => {
                        for(let i=0;i<this.$store.state.companyJobs.length;i++){
                            if(this.$store.state.companyJobs[i].name==this.$store.state.patient.jobCompany){
                                console.log(this.$store.state.companyJobs[i])
                            for(let j=0;j<this.$store.state.companyJobs[i].jobMeasures.length;j++){
                                for(let k=0;k<this.$store.state.companyJobs[i].jobMeasures[j].jobMeasureDets.length;k++){
                                    if(this.$store.state.companyJobs[i].jobMeasures[j].jobMeasureDets[k].measure=='Ruido - sonometría'){
                                        this.sonometria= this.$store.state.companyJobs[i].jobMeasures[j].jobMeasureDets[k].value+" "+this.$store.state.companyJobs[i].jobMeasures[j].jobMeasureDets[k].unit
                                    }
                                    if(this.$store.state.companyJobs[i].jobMeasures[j].jobMeasureDets[k].measure=='Ruido - dosimetría'){
                                        this.dosimetria= this.$store.state.companyJobs[i].jobMeasures[j].jobMeasureDets[k].value+" "+this.$store.state.companyJobs[i].jobMeasures[j].jobMeasureDets[k].unit
                                    }
                                }
                            }
                            }
                        }

                    }, error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                    })

            },

            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },

        },
        computed: {},
        created() {
            this.reloadData()
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patient/monitoreo/MonitoreoAuditivo.vue